import { jsonSchema } from 'ai';
import { toLlmJsonSchema } from '../../../utils/zodJsonSchema';
export const createAgentInputSchema = (inputSchema) => jsonSchema(toLlmJsonSchema(inputSchema, { reused: 'ref' }), {
    validate: (value) => {
        const result = inputSchema.safeParse(value);
        if (result.success) {
            return { success: true, value: result.data };
        }
        return { success: false, error: result.error };
    },
});
//# sourceMappingURL=agentInputSchema.js.map